var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaybekLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 39,
    viewBox: "0 0 139 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5928_6093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1797 12.5147C52.1797 11.5459 52.6641 11.0615 53.6329 11.0615H58.9587C62.8339 11.0615 65.4968 13.2401 65.4968 17.1152C65.4968 20.9904 62.5905 23.1689 58.7178 23.1689H55.0861V27.7694C55.0861 28.4948 54.3607 29.2226 53.6329 29.2226C52.905 29.2226 52.1797 28.4973 52.1797 27.7694V12.5147ZM55.0861 20.5035H58.9587C61.1373 20.5035 62.5905 19.2938 62.5905 17.1127C62.5905 14.9317 61.1373 13.722 58.9587 13.722H55.0861V20.501V20.5035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7501 17.3589V28.0131C80.7501 28.9819 80.0247 29.4663 79.2969 29.4663C78.5691 29.4663 77.8437 28.9819 77.8437 28.0131V26.5599C77.1184 28.4975 75.1808 29.4663 72.7588 29.4663C68.6427 29.4663 66.2207 26.319 66.2207 22.4463C66.2207 18.5736 68.8836 15.4238 72.9998 15.4238C74.9373 15.4238 76.8724 16.3926 77.8412 18.0868V17.118C77.8412 16.1492 78.5666 15.6648 79.2944 15.6648C80.0198 15.9057 80.7476 16.3901 80.7476 17.3589H80.7501ZM77.8437 22.6848C77.8437 20.2628 76.1496 18.3277 73.4866 18.3277C71.0647 18.3277 69.1296 20.0219 69.1296 22.6848C69.1296 25.1068 70.8237 27.0419 73.4866 27.0419C75.9086 26.8009 77.8437 25.1043 77.8437 22.6848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5832 15.6621C94.3086 15.6621 95.0364 16.1465 95.0364 17.1153V17.8406L88.2574 34.5461C88.0164 35.2714 87.532 35.5148 86.8042 35.5148C86.0763 35.5148 85.351 35.0305 85.351 34.0617C85.351 33.8182 85.351 33.5773 85.5919 33.3363L87.2861 29.2202L82.4446 17.8406C82.4446 17.5997 82.2012 17.3563 82.2012 17.3563C82.2012 16.6309 82.9265 15.9031 83.8953 15.9031C84.3797 15.9031 84.8641 16.1465 85.3485 16.8719C87.0426 21.4724 88.2549 24.1353 88.9802 26.5573C89.7056 24.1353 90.6744 21.7158 92.371 16.8719C92.6119 16.1465 93.0963 15.6621 93.5807 15.6621H93.5832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.257 22.6843C111.257 26.557 108.594 29.7068 104.478 29.7068C102.541 29.7068 100.606 28.738 99.6368 27.0439V28.0126C99.6368 28.9814 98.9115 29.4658 98.1837 29.4658C97.4558 29.4658 96.7305 28.9814 96.7305 28.0126V11.3047C96.7305 10.336 97.4558 9.85156 98.1837 9.85156C98.9115 9.85156 99.6368 10.336 99.6368 11.3047V18.5682C100.362 16.6306 102.3 15.6618 104.722 15.6618C108.597 15.6618 111.26 18.8091 111.26 22.6843H111.257ZM108.11 22.6843C108.11 20.2623 106.172 18.3272 103.753 18.3272C101.333 18.3272 99.3959 20.2648 99.3959 22.6843C99.3959 25.1038 101.09 27.0414 103.753 27.0414C106.416 26.8004 108.11 25.1038 108.11 22.6843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.089 23.4102H114.888C114.888 25.5888 116.825 27.0419 119.004 27.0419C120.698 27.0419 121.667 26.3166 122.395 25.3478C122.636 24.8634 123.12 24.8634 123.363 24.8634C124.089 24.8634 124.573 25.5888 124.573 26.0731C124.573 26.3141 124.573 26.5575 124.332 26.7985C123.122 28.2517 121.426 29.4614 119.006 29.4614C114.89 29.4614 111.986 26.7985 111.986 22.4414C111.986 18.5663 114.893 15.4189 118.765 15.4189C122.638 15.4189 125.06 17.8409 125.544 21.7136C125.785 22.9233 125.06 23.4077 124.091 23.4077L124.089 23.4102ZM114.888 21.4726H122.636C122.395 19.5351 120.941 18.0844 118.763 18.0844C116.584 18.0844 115.131 19.5375 114.89 21.4726H114.888Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.889 27.2851C138.132 27.526 138.132 27.7695 138.132 28.0104C138.132 28.7358 137.407 29.4636 136.679 29.4636C136.438 29.4636 135.954 29.2227 135.71 28.9792L129.656 22.9255V27.767C129.656 28.4923 129.172 29.2202 128.203 29.2202C127.478 29.2202 126.75 28.4948 126.75 27.767V11.0616C126.75 10.3362 127.475 9.6084 128.203 9.6084C128.931 9.6084 129.656 10.3337 129.656 11.0616C129.656 15.903 129.656 18.8094 129.415 20.988L135.469 15.903C135.953 15.6621 136.438 15.4187 136.679 15.4187C137.404 15.4187 137.889 15.903 137.889 16.3874C137.889 16.6284 137.648 17.1128 137.404 17.3562L132.319 21.7133L137.889 27.2826V27.2851Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2018 13.2372V7.47168C5.47242 7.47168 0 12.8845 0 19.5592H5.81026C5.81026 16.0566 8.67191 13.2372 12.2018 13.2372Z",
    fill: "url(#paint0_linear_5928_6093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5927 19.5592H24.403C24.403 12.882 18.9305 7.47168 12.2012 7.47168V13.2372C15.731 13.2372 18.5927 16.0566 18.5927 19.5592Z",
    fill: "url(#paint1_linear_5928_6093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6011 16.6607C18.6011 18.2617 19.8985 19.5596 21.4988 19.5596C23.0992 19.5596 24.3965 18.2617 24.3965 16.6607L24.3965 2.89887C24.3965 1.29784 23.0992 -4.57764e-05 21.4988 -4.57764e-05C19.8985 -4.57764e-05 18.6011 1.29784 18.6011 2.89887V16.6607Z",
    fill: "url(#paint2_linear_5928_6093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1929 19.5596C37.1929 23.0621 34.3313 25.9213 30.8014 25.9213C27.2715 25.9213 24.4099 23.0621 24.4099 19.5596H18.5996C18.5996 26.2368 24.072 31.6868 30.8014 31.6868C37.5308 31.6868 43.0032 26.2343 43.0032 19.5596H37.1929Z",
    fill: "url(#paint3_linear_5928_6093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8045 7.47168C24.0776 7.47168 18.6027 12.882 18.6027 19.5592H18.6226C18.6226 23.0617 15.761 25.9209 12.2311 25.9209C8.70121 25.9209 5.83955 23.0617 5.83955 19.5592H0.0292969C0.0292969 26.2364 5.50172 31.6865 12.2311 31.6865C18.9604 31.6865 24.4329 26.2339 24.4329 19.5592H24.413C24.413 16.0566 27.2746 13.2372 30.8045 13.2372C34.3344 13.2372 37.1961 16.0566 37.1961 19.5592H43.0063C43.0063 12.882 37.5339 7.47168 30.8045 7.47168Z",
    fill: "url(#paint4_linear_5928_6093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0669372 19.5596H5.86229V36.101C5.86229 37.7008 4.56312 39 2.96337 39C1.36363 39 0.0644531 37.7008 0.0644531 36.101V19.5596H0.0669372Z",
    fill: "url(#paint5_linear_5928_6093)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5928_6093",
    x1: 8.06828,
    y1: 13.5154,
    x2: 23.2385,
    y2: 13.5154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1652F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5928_6093",
    x1: 8.06767,
    y1: 13.5154,
    x2: 23.2379,
    y2: 13.5154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1652F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5928_6093",
    x1: 21.5001,
    y1: 9.11155,
    x2: 21.5001,
    y2: -0.357753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1636F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5928_6093",
    x1: 29.3432,
    y1: 22.2051,
    x2: 35.2106,
    y2: 25.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1636F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5928_6093",
    x1: 0.0292969,
    y1: 19.5816,
    x2: 36.431,
    y2: 19.5816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1652F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5928_6093",
    x1: 2.96337,
    y1: 21.2314,
    x2: 2.96337,
    y2: 38.9627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1652F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5928_6093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.132,
    height: 39,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaybekLogo);
export default __webpack_public_path__ + "static/media/Paybek_logo.bd0612f243303c45e35cf87d70f1abeb.svg";
export { ForwardRef as ReactComponent };